export default __webpack_public_path__ + "static/media/close.dd287d17.svg";